/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'

/**
 * Declare Variable
 */
const defaultIsSwitchOnEditModeState = true
const defaultIsStickyNavbarSwiperState = false
const defaultIsSwitchClearAllOrdersState = false

/**
 * Export
 */

export const isSwitchOnEditMode = handleActions({
  SWITCH_EDIT_MODE: (state, action) => {
    return action.payload
  },
}, defaultIsSwitchOnEditModeState)

export const isStickyNavbarSwiper = handleActions({
  IS_STICKY_NAVBAR_SWIPER: (state, action) => {
    return action.payload
  },
}, defaultIsStickyNavbarSwiperState)

export const isSwitchClearAllOrdersMode = handleActions({
  SWITCH_CLEAR_ALL_ORDERS: (state, action) => {
    return action.payload
  },
}, defaultIsSwitchClearAllOrdersState)

export default {
  isSwitchOnEditMode,
  isStickyNavbarSwiper,
  isSwitchClearAllOrdersMode,
}



// WEBPACK FOOTER //
// ./src/reducers/components/navbar.js